<template>
  <el-container>
    <el-main>
      <router-view
        :key="appName"
        v-slot="{ Component, route }"
      >
        <keep-alive :max="60">
          <component
            ref="component"
            :is="Component"
            :key="route.path"
          />
        </keep-alive>
      </router-view>
    </el-main>
  </el-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import shared from '@/micro/shared'
shared.setAppName('admin')

const appName = computed(() => {
  return shared.getAppName()
})
</script>

<style lang="less" scoped>
.el-aside {
  width: auto;
  background-color: #304156;
  color: @whiteColor;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
}
</style>
